import {isZahavOnlyAmount} from '@sollapay/domain';
import {TransferType} from '@sollapay/enums';
import {useCallback, useState} from 'react';

import {DEFAULT_PAYMENT_TRANSFER_TYPE} from '@/features/buyers/constants';

import type {PayinTransferType} from '@sollapay/enums';

/** The lawyer's transfer-type pick — overridden to zahav while the amount is zahav-only. */
export function usePaymentTransferType(amount: string) {
  const [selectedTransferType, setTransferType] = useState<PayinTransferType>(
    DEFAULT_PAYMENT_TRANSFER_TYPE
  );
  const isZahavOnly = isZahavOnlyAmount(amount);

  const resetTransferType = useCallback(() => setTransferType(DEFAULT_PAYMENT_TRANSFER_TYPE), []);

  return {
    transferType: isZahavOnly ? TransferType.ZAHAV : selectedTransferType,
    isZahavOnly,
    setTransferType,
    resetTransferType
  };
}
